export const sendToApproveFormItem = {
  APPROVER_ID: 'approverId',
  COMMENT: 'comment'
} as const
